<template>
    <div class="clients-list">
        <div class="list-header">
            <div>
                <span>Nome</span>
            </div>
            <div>
                <span>Email</span>
            </div>
            <div>
                <span>Código</span>
            </div>
            <div>
                <span>Progresso (Mensal)</span>
            </div>
        </div>

        <div class="list" v-for="item in data" :key="item._id" @click="$emit('open-modal', item._id)">
            <div>
                <span>{{ item.name }}</span>
            </div>

            <div>
                <span>{{ item.email }}</span>
            </div>

            <div>
                <span>{{ item.plannerCode || '------' }}</span>
            </div>

            <div
                :title="`Realizado: ${formatNumber(Math.abs(item.financeStatus.spended))} | Projetado: ${formatNumber(item.financeStatus.planned)}`"
            >
                <v-tooltip color="#028fff" bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div class="progress-bar-container">
                            <div style="justify-content: flex-end; width: 100%">
                                <div class="row" style="justify-content: space-between; display: flex">
                                    <div class="subtitle"></div>

                                    <div
                                        style="margin-bottom: 4px"
                                        class="chart-text percentage"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        {{
                                            Math.abs(
                                                monthPercentage(
                                                    item.financeStatus.spended,
                                                    item.financeStatus.planned,
                                                ).toFixed(0),
                                            )
                                        }}%
                                    </div>
                                </div>
                            </div>

                            <div class="progress-bar-border second">
                                <div
                                    class="progress-bar"
                                    :class="
                                        monthPercentage(item.financeStatus.spended, item.financeStatus.planned) < 100
                                            ? 'green-background'
                                            : 'red-background'
                                    "
                                    :style="{
                                        width:
                                            monthPercentage(item.financeStatus.spended, item.financeStatus.planned) +
                                            '%',
                                    }"
                                ></div>
                            </div>
                        </div>

                        <div style="margin-top: 2px" class="text-box">
                            <p>
                                <span>{{ formatNumber(Math.abs(item.financeStatus.spended)) }}</span>
                            </p>

                            <p>
                                <span>{{ formatNumber(item.financeStatus.planned) }}</span>
                            </p>
                        </div>
                    </template>
                </v-tooltip>
            </div>
        </div>
    </div>
</template>

<script setup>
import util from '../../common/util'

defineProps({
    data: {
        type: Array,
        default: () => [],
    },
})

defineEmits(['open-modal'])

const formatNumber = util.formatNumber

const monthPercentage = (spended, planned) => {
    return Math.abs(util.percentage(spended, planned))
}
</script>

<style lang="scss">
.clients-list {
    @include easy-progress-bar();

    .list-header {
        display: grid;
        grid-template-columns: 2.5fr 1fr 0.5fr 1.5fr;
        grid-template-rows: 1fr;
        gap: 0px 0px;
        grid-template-areas: 'name email code status';
        height: 30px;
        box-shadow: 0px 0px 7px #0000001a;
        margin-bottom: 2px;
        background-color: $lighter-grey;

        & > div {
            color: $darker-blue;
            align-self: center;
            padding: 0 16px;
            text-transform: uppercase;
            font-weight: bold;
        }
    }

    .list {
        display: grid;
        grid-template-columns: 2.5fr 1fr 0.5fr 1.5fr;
        grid-template-rows: 1fr;
        gap: 0px 0px;
        grid-template-areas: 'name email code status';
        height: 60px;
        box-shadow: 0px 0px 7px #0000001a;
        margin-bottom: 2px;
        cursor: pointer;

        & > div {
            color: $darker-blue;
            align-self: center;
            padding: 0 16px;
        }

        & > div:last-child {
            font-size: 12px;
        }
    }

    .progress-bar-border.second {
        .green-background {
            background-color: #efb256;
        }

        .red-background {
            background-color: $hint-red;
        }
    }

    .text-box {
        @include flex-between();
        width: 90%;

        & > p {
            font-size: 10px;
            font-weight: 500;
        }
    }
}
</style>
